import { FileInput, MultipleToggableDropdown, Notification, STATUS_TYPES } from 'dyl-components';
import React, { createRef, useMemo, useState } from 'react';
import { Controller } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { Form, Input, Segment, Icon, Popup } from 'semantic-ui-react';
import FileUtils, { FILE_CATEGORIES } from 'utils/FileUtils';

const ImportSetup = ({
    control,
    onUpload,
    importSetupFields,
    dropzoneRef = createRef(),
    watch
}) => {
    const { assigned_owners = [], isReadingOwnersAndCoowners } = useSelector(state => state.contact);
    const ownedByCategories = useMemo(() => assigned_owners.map(owner => ({
        key: owner.id,
        value: owner.id.toString(),
        text: owner.username,
    })).filter((owner) => owner.key !== 0),
        [assigned_owners]);
    const [search, setSearch] = useState("");
    const onSearchChange = (e, { value }) => {
        setSearch(value);
    }
    return (
        <Form noValidate>
            <Form.Group>
                <Controller
                    name="file"
                    defaultValue={[]}
                    control={control}
                    render={({ field: { onChange, value, name }, fieldState: { error } }) => (
                        <Form.Field
                            width={6}
                            control={Input}
                            error={error && error.message && {
                                pointing: 'below'
                            }}
                            className='Template__attachments-section'
                        >
                            <Segment style={{ width: '100%', padding: 0 }} basic>
                                <div>
                                    <Icon disabled={value.length > 0} onClick={() => { dropzoneRef.current.open() }} color='blue' name='plus circle' link /> <b>Attach {value.length > 0 && 'more '}files</b>
                                </div>
                                <div className='Template__attachments' style={{ marginBottom: 10 }}>
                                    <FileInput
                                        onChange={(_, { value }) => {
                                            if (value.length > 1) {
                                                Notification.alert("Only accepts one .csv file.", STATUS_TYPES.ERROR, true);
                                            } else {
                                                onChange({
                                                    target: { name, value }
                                                })
                                                onUpload(value);
                                            }
                                        }}
                                        onRemove={(_, { value }) => {
                                            onChange({ target: { name, value } });
                                        }}
                                        onReject={(rejected) => {
                                            if (rejected.length > 0) {
                                                Notification.alert("Only accepts .csv files.", STATUS_TYPES.ERROR, true);
                                            }
                                        }}
                                        files={value}
                                        name="file"
                                        accept="text/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                        icon="file csv outline"
                                        size="mini"
                                        dropzoneRef={dropzoneRef}
                                        showIcon
                                        hasBrowse
                                    />
                                </div>
                                <i>Remaining: {FileUtils.getRemainingSize(value, FILE_CATEGORIES.IMPORT)} MB </i> {error?.message && `(${error.message})`}
                            </Segment>
                        </Form.Field>
                    )}
                />
                <Form.Field
                    control='div'
                    width={8}
                >
                    <Controller
                        control={control}
                        name='description'
                        render={({ field: { name, value, onChange }, fieldState: { error } }) => (
                            <Form.Input
                                label='File Description'
                                name={name}
                                value={value}
                                onChange={(_, { value }) => {
                                    onChange({ target: { name, value } });
                                }}
                                error={error?.message}
                                required
                                placeholder='Enter file description'
                            />
                        )}
                    />
                    <Form.Group widths='equal'>
                        {importSetupFields}
                    </Form.Group>
                    { watch("duplicate_option") !== "merge_only" &&
                        <Form.Group style={{ alignItems: 'center', marginTop: 15 }}>
                            <Form.Field width={2}>
                                <label>Assignment</label>
                            </Form.Field>

                            <Form.Field width={3}>
                                <Controller
                                    name="assignmentType"
                                    control={control}
                                    defaultValue="unassigned"
                                    render={({ field: { value, onChange } }) => (
                                        <Form.Radio
                                            label="Unassigned"
                                            value="unassigned"
                                            checked={value === "unassigned"}
                                            onChange={() => onChange("unassigned")}
                                        />
                                    )}
                                />
                            </Form.Field>

                            <Form.Field width={3}>
                                <Controller
                                    name="assignmentType"
                                    control={control}
                                    render={({ field: { value, onChange } }) => (
                                        <Form.Radio
                                            label="Auto-Assign"
                                            value="auto"
                                            checked={value === "auto"}
                                            onChange={() => onChange("auto")}
                                        />
                                    )}
                                />
                            </Form.Field>

                            <Form.Field width={9} disabled={watch("assignmentType") === "unassigned"}>
                                <Controller
                                    name='owners'
                                    control={control}
                                    render={({ field: { name, value, onChange } }) => (
                                        <Form.Field
                                            control={MultipleToggableDropdown}
                                            values={value || []}
                                            className="CallsByAgent__MultipleToggableDropdown"
                                            nested_options={ownedByCategories}
                                            onChange={(_, { value }) => {
                                                setSearch("");
                                                onChange({ target: { name, value } });
                                            }}
                                            searchValue={search}
                                            placeholder='Search users'
                                            onHoverParent={() => { }}
                                            onSearchChange={onSearchChange}
                                            loading={isReadingOwnersAndCoowners}
                                            isExpandable
                                        />
                                    )}
                                />
                            </Form.Field>
                            <Form.Field width={1}>
                                <Popup
                                    content={"New records will be assigned round robin"}
                                    position="top right"
                                    inverted
                                    trigger={
                                        <Icon
                                            className="fas fa-info-circle"
                                            color="primary"
                                        />
                                    }
                                />
                            </Form.Field>
                        </Form.Group>
                    }
                </Form.Field>
            </Form.Group>
        </Form>
    )
};

export default ImportSetup;